export default "__VITE_ASSET__BtEzh0Hy__"